const projects = [
  {
    id: 1,
    title: "E-commerce Website for Direct Trade",
    description:
      "Developed using MERN stack (MongoDB, Express.js, React, Node.js) to facilitate direct trade between buyers and sellers.",
    github: "https://github.com/Habtamu43?tab=repositories",
    demo: "#",
  },
  {
    id: 2,
    title: "User Authentication System",
    description:
      "Built with Python, featuring secure user login and registration functionality.",
    github: "https://github.com/Habtamu43?tab=repositories",
    demo: "#",
  },
  {
    id: 3,
    title: "Social Media App",
    description:
      "Created using PHP, allowing users to create profiles, post updates, and interact with each other.",
    github: "https://github.com/Habtamu43?tab=repositories",
    demo: "#",
  },
  {
    id: 4,
    title: "Task CRUD System",
    description:
      "Developed with PHP, enabling users to create, read, update, and delete tasks efficiently.",
    github: "https://github.com/Habtamu43/php-task-crud",
    demo: "#",
  },
];

export default projects;
